export interface SocialPost {
  id: number;
  authorType: "radio" | "program" | "host";
  authorId: number;
  authorName: string;
  authorAvatar: string;
  authorSubtitle: string;
  authorLink: string;
  timestamp: string;
  content: string;
  postType: "text" | "photo" | "video" | "poll" | "event" | "contest";
  imageUrl?: string;
  videoUrl?: string;
  pollOptions?: { id: number; text: string; votes: number }[];
  pollTotalVotes?: number;
  pollUserVote?: number;
  eventDate?: string;
  eventLocation?: string;
  contestPrize?: string;
  contestEndDate?: string;
  likes: number;
  comments: number;
  shares: number;
  userLiked: boolean;
  tags: string[];
}

export const socialFeedPosts: SocialPost[] = [
  {
    id: 1,
    authorType: "radio",
    authorId: 1,
    authorName: "Estéreo Capital",
    authorAvatar: "https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20circular%20design%20with%20sound%20waves%20and%20urban%20skyline%20silhouette%2C%20vibrant%20coral%20and%20warm%20orange%20gradient%2C%20clean%20minimalist%20broadcast%20emblem%2C%20isolated%20on%20transparent%20background%2C%20vector%20style&width=200&height=200&seq=feed-avatar-radio-1&orientation=squarish",
    authorSubtitle: "102.7 FM RFW · 12.4K seguidores",
    authorLink: "/radio/102-7",
    timestamp: "2026-06-21T14:30:00Z",
    content: "¡BUENAS TARDES CAPITALINOS! Ya está al aire Carrusel Deportivo con toda la previa del partido de esta noche. ¿Quién creen que se lleva la victoria? ¡Los leemos en los comentarios! ⚽🔥",
    postType: "photo",
    imageUrl: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20studio%20scene%20with%20multiple%20microphones%20and%20mixing%20console%2C%20warm%20amber%20and%20red%20ambient%20lighting%2C%20professional%20broadcast%20equipment%2C%20sports%20memorabilia%20on%20walls%2C%20energetic%20atmosphere%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20realistic%20studio%20environment&width=800&height=500&seq=feed-post-1&orientation=landscape",
    likes: 847,
    comments: 203,
    shares: 89,
    userLiked: true,
    tags: ["Deportes", "Fútbol", "EnVivo"],
  },
  {
    id: 2,
    authorType: "host",
    authorId: 7,
    authorName: "Isabella Torres",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%20with%20warm%20genuine%20smile%2C%20elegant%20casual%20blazer%20in%20soft%20beige%20tone%2C%20modern%20studio%20background%20with%20warm%20diffused%20lighting%2C%20confident%20and%20approachable%20editorial%20headshot%20photography%2C%20clean%20composition&width=200&height=200&seq=feed-avatar-host-7&orientation=squarish",
    authorSubtitle: "Locutora · Élite Digital · 8.2K seguidores",
    authorLink: "/host/isabella-torres",
    timestamp: "2026-06-21T13:15:00Z",
    content: "Esta tarde en Mundo Digital vamos a hablar de inteligencia artificial y el futuro del audio. Tengo un invitado SORPRESA que no se pueden perder. ¿Tienen preguntas sobre IA? ¡Déjenlas aquí y las respondemos al aire! 🎙️🤖",
    postType: "poll",
    pollOptions: [
      { id: 1, text: "Me encanta la IA, quiero saber todo", votes: 456 },
      { id: 2, text: "Me interesa pero me preocupa", votes: 312 },
      { id: 3, text: "Prefiero el contenido sin tecnología", votes: 98 },
    ],
    pollTotalVotes: 866,
    pollUserVote: 1,
    likes: 634,
    comments: 178,
    shares: 45,
    userLiked: false,
    tags: ["Tecnología", "Podcast", "IA"],
  },
  {
    id: 3,
    authorType: "program",
    authorId: 1,
    authorName: "Carrusel Deportivo",
    authorAvatar: "https://readdy.ai/api/search-image?query=Sports%20talk%20show%20logo%20design%20with%20dynamic%20typography%20and%20ball%20icon%2C%20energetic%20red%20and%20white%20color%20scheme%2C%20circular%20emblem%20style%2C%20modern%20sports%20broadcast%20identity%2C%20clean%20vector%20design%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-prog-1&orientation=squarish",
    authorSubtitle: "Programa · Estéreo Capital · 5.6K seguidores",
    authorLink: "/program/carrusel-deportivo",
    timestamp: "2026-06-21T12:00:00Z",
    content: "¡SORTEO EXCLUSIVO! 🎁 Ganá 2 entradas VIP para la final del campeonato nacional. Solo tenés que:\n\n1️⃣ Seguir a @CarruselDeportivo\n2️⃣ Compartir este post\n3️⃣ Comentar con tu equipo favorito\n\nEl ganador lo anunciamos mañana al aire. ¡Suerte! 🏆",
    postType: "contest",
    contestPrize: "2 entradas VIP - Final Campeonato Nacional",
    contestEndDate: "2026-06-22T18:00:00Z",
    likes: 2341,
    comments: 892,
    shares: 567,
    userLiked: true,
    tags: ["Concurso", "Fútbol", "EntradasVIP"],
  },
  {
    id: 4,
    authorType: "radio",
    authorId: 3,
    authorName: "Deportiva Total",
    authorAvatar: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20dynamic%20shield%20shape%20and%20star%20elements%2C%20bold%20navy%20and%20gold%20color%20scheme%2C%20professional%20sports%20broadcast%20emblem%2C%20clean%20vector%20design%20on%20transparent%20background%2C%20authoritative%20style&width=200&height=200&seq=feed-avatar-radio-3&orientation=squarish",
    authorSubtitle: "101.5 FM RFW · 18.7K seguidores",
    authorLink: "/radio/101-5",
    timestamp: "2026-06-21T11:45:00Z",
    content: "ALERTA DE ÚLTIMO MOMENTE: Se confirma el fichaje bomba del mercado. Todos los detalles en exclusiva por Deportiva Total. ¡No cambien de dial! 📻⚡",
    postType: "text",
    likes: 1567,
    comments: 423,
    shares: 312,
    userLiked: false,
    tags: ["Exclusiva", "Fichaje", "ÚltimoMomento"],
  },
  {
    id: 5,
    authorType: "host",
    authorId: 1,
    authorName: "Javier Mendoza",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20male%20radio%20host%20portrait%20with%20confident%20friendly%20expression%2C%20casual%20navy%20blazer%20and%20white%20shirt%2C%20warm%20studio%20lighting%20on%20neutral%20background%2C%20approachable%20editorial%20headshot%20photography%2C%20clean%20modern%20composition&width=200&height=200&seq=feed-avatar-host-1&orientation=squarish",
    authorSubtitle: "Locutor Principal · Deportiva Total · 15.3K seguidores",
    authorLink: "/host/javier-mendoza",
    timestamp: "2026-06-21T10:30:00Z",
    content: "Mañana imperdible en Deportiva Total. Entrevista EXCLUSIVA con la leyenda del fútbol latinoamericano. Preparen sus preguntas que vamos a estar leyendo en vivo. ¡Esto va a ser HISTÓRICO! 🎙️🌟",
    postType: "event",
    eventDate: "2026-06-22T09:00:00Z",
    eventLocation: "Deportiva Total · 101.5 FM RFW",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20sports%20interview%20studio%20setup%20with%20two%20chairs%20facing%20each%20other%2C%20professional%20broadcast%20lighting%20with%20warm%20amber%20and%20cool%20blue%20tones%2C%20large%20screen%20displaying%20sports%20statistics%2C%20cinematic%20editorial%20photography%2C%20atmospheric%20depth%20and%20professional%20broadcast%20environment&width=800&height=500&seq=feed-post-5&orientation=landscape",
    likes: 2891,
    comments: 567,
    shares: 423,
    userLiked: true,
    tags: ["Entrevista", "Exclusiva", "Leyenda"],
  },
  {
    id: 6,
    authorType: "radio",
    authorId: 6,
    authorName: "Éxito FM",
    authorAvatar: "https://readdy.ai/api/search-image?query=Vibrant%20pop%20music%20radio%20station%20logo%20with%20star%20and%20microphone%20elements%2C%20bright%20coral%20and%20yellow%20gradient%20colors%2C%20energetic%20modern%20broadcast%20emblem%2C%20circular%20design%2C%20clean%20vector%20style%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-radio-6&orientation=squarish",
    authorSubtitle: "95.3 FM RFW · 9.8K seguidores",
    authorLink: "/radio/95-3",
    timestamp: "2026-06-20T22:00:00Z",
    content: "Así se vivió el cierre de nuestro festival de verano. ¡GRACIAS a todos los que vinieron! La energía fue INCREÍBLE. ¿Quieren que repitamos? 🔥🎵",
    postType: "video",
    imageUrl: "https://readdy.ai/api/search-image?query=Summer%20music%20festival%20crowd%20scene%20with%20colorful%20stage%20lighting%2C%20hands%20raised%20in%20the%20air%2C%20vibrant%20concert%20atmosphere%20with%20warm%20pink%20and%20purple%20tones%2C%20energetic%20celebration%20mood%2C%20editorial%20concert%20photography%20with%20dramatic%20lighting%20and%20crowd%20energy%2C%20wide%20angle%20composition&width=800&height=500&seq=feed-post-6&orientation=landscape",
    likes: 3456,
    comments: 678,
    shares: 234,
    userLiked: false,
    tags: ["Festival", "Verano", "MúsicaEnVivo"],
  },
  {
    id: 7,
    authorType: "host",
    authorId: 3,
    authorName: "Daniel Ortega",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20male%20radio%20commentator%20portrait%20with%20engaging%20expression%2C%20wearing%20casual%20dark%20polo%20shirt%2C%20modern%20broadcast%20studio%20background%20with%20warm%20ambient%20lighting%2C%20confident%20editorial%20headshot%20photography%2C%20clean%20approachable%20composition&width=200&height=200&seq=feed-avatar-host-3&orientation=squarish",
    authorSubtitle: "Comentarista · Deportiva Total · 6.4K seguidores",
    authorLink: "/host/daniel-ortega",
    timestamp: "2026-06-20T18:45:00Z",
    content: "ANÁLISIS TÁCTICO: Les traigo el desglose completo de la jornada. ¿Cuál fue el mejor gol del fin de semana? Voten en la encuesta y lo analizamos mañana. ⚽📊",
    postType: "poll",
    pollOptions: [
      { id: 1, text: "Golazo de tiro libre - Minuto 78", votes: 523 },
      { id: 2, text: "Chilena espectacular - Minuto 34", votes: 687 },
      { id: 3, text: "Contragolpe perfecto - Minuto 12", votes: 234 },
      { id: 4, text: "Cabezazo en el último minuto", votes: 198 },
    ],
    pollTotalVotes: 1642,
    pollUserVote: undefined,
    likes: 456,
    comments: 234,
    shares: 67,
    userLiked: false,
    tags: ["Análisis", "Fútbol", "Goles"],
  },
  {
    id: 8,
    authorType: "program",
    authorId: 3,
    authorName: "Mundo Digital",
    authorAvatar: "https://readdy.ai/api/search-image?query=Technology%20podcast%20show%20logo%20with%20circuit%20board%20pattern%20and%20digital%20wave%2C%20modern%20teal%20and%20white%20color%20scheme%2C%20circular%20emblem%20design%2C%20clean%20tech-savvy%20broadcast%20identity%2C%20vector%20style%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-prog-3&orientation=squarish",
    authorSubtitle: "Programa · Élite Digital · 3.2K seguidores",
    authorLink: "/program/mundo-digital",
    timestamp: "2026-06-20T16:00:00Z",
    content: "NUEVO EPISODIO: \"El futuro del streaming de audio\". Analizamos las tendencias que van a cambiar cómo escuchamos radio en los próximos 5 años. Disponible en todas las plataformas. 🎧🚀",
    postType: "photo",
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20podcast%20studio%20setup%20with%20modern%20audio%20equipment%20and%20neon%20accent%20lighting%2C%20cyan%20and%20purple%20ambient%20glow%2C%20sleek%20minimalist%20broadcast%20desk%20with%20digital%20displays%2C%20technology%20focused%20editorial%20photography%2C%20clean%20modern%20composition&width=800&height=500&seq=feed-post-8&orientation=landscape",
    likes: 234,
    comments: 89,
    shares: 123,
    userLiked: true,
    tags: ["Podcast", "Streaming", "Tecnología"],
  },
  {
    id: 9,
    authorType: "radio",
    authorId: 8,
    authorName: "Caribe FM",
    authorAvatar: "https://readdy.ai/api/search-image?query=Tropical%20Caribbean%20radio%20station%20logo%20with%20palm%20tree%20and%20ocean%20wave%20elements%2C%20vibrant%20turquoise%20and%20warm%20coral%20gradient%2C%20festive%20island%20broadcast%20emblem%2C%20circular%20design%2C%20clean%20vector%20style%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-radio-8&orientation=squarish",
    authorSubtitle: "98.7 FM RFW · 7.1K seguidores",
    authorLink: "/radio/98-7",
    timestamp: "2026-06-20T14:30:00Z",
    content: "¡VIERNES DE RUMBA! 🕺💃 Preparate para el mejor playlist de salsa, merengue y ritmos caribeños. Hoy con invitado especial desde La Habana. ¡No te lo pierdas!",
    postType: "photo",
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20tropical%20dance%20party%20scene%20with%20colorful%20bunting%20and%20warm%20sunset%20lighting%2C%20people%20dancing%20salsa%20with%20joyful%20expressions%2C%20Caribbean%20atmosphere%20with%20palm%20silhouettes%2C%20festive%20warm%20orange%20and%20pink%20tones%2C%20energetic%20editorial%20photography%20capturing%20celebration%20mood&width=800&height=500&seq=feed-post-9&orientation=landscape",
    likes: 1876,
    comments: 345,
    shares: 167,
    userLiked: false,
    tags: ["Salsa", "Caribe", "ViernesDeRumba"],
  },
  {
    id: 10,
    authorType: "host",
    authorId: 12,
    authorName: "Adriana Mejía",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%20with%20warm%20welcoming%20smile%2C%20elegant%20casual%20style%20in%20soft%20burgundy%20top%2C%20sophisticated%20studio%20environment%20with%20warm%20golden%20lighting%2C%20graceful%20editorial%20headshot%20photography%2C%20clean%20refined%20composition&width=200&height=200&seq=feed-avatar-host-12&orientation=squarish",
    authorSubtitle: "Locutora · Éxito FM · 5.7K seguidores",
    authorLink: "/host/adriana-mejia",
    timestamp: "2026-06-20T10:00:00Z",
    content: "Mañana en Éxito Total estamos de fiesta. ¡Celebramos 100 programas al aire! Vamos a tener sorpresas, regalos y un invitado MUY especial. ¿Quién creen que viene? Dejen sus apuestas 🎉🎂",
    postType: "event",
    eventDate: "2026-06-21T08:00:00Z",
    eventLocation: "Éxito FM · 95.3 FM RFW",
    imageUrl: "https://readdy.ai/api/search-image?query=Celebration%20scene%20in%20radio%20studio%20with%20balloons%20and%20confetti%2C%20golden%20and%20warm%20festive%20lighting%2C%20professional%20broadcast%20equipment%20decorated%20for%20party%2C%20joyful%20celebratory%20atmosphere%2C%20editorial%20photography%20capturing%20special%20milestone%20moment%2C%20bright%20and%20warm%20composition&width=800&height=500&seq=feed-post-10&orientation=landscape",
    likes: 1234,
    comments: 289,
    shares: 98,
    userLiked: true,
    tags: ["100Programas", "Celebración", "ÉxitoTotal"],
  },
  {
    id: 11,
    authorType: "radio",
    authorId: 10,
    authorName: "Rock Nacional",
    authorAvatar: "https://readdy.ai/api/search-image?query=Rock%20music%20radio%20station%20logo%20with%20electric%20guitar%20and%20amplifier%20elements%2C%20bold%20dark%20charcoal%20and%20crimson%20red%20color%20scheme%2C%20edgy%20modern%20broadcast%20emblem%2C%20circular%20design%2C%20clean%20vector%20style%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-radio-10&orientation=squarish",
    authorSubtitle: "107.1 FM RFW · 11.2K seguidores",
    authorLink: "/radio/107-1",
    timestamp: "2026-06-19T23:00:00Z",
    content: "¡MEDIANOCHE DE CLÁSICOS! Esta noche programación especial: los mejores álbumes de rock nacional de todos los tiempos, de principio a fin. Sin interrupciones. Puro rock. 🤘🎸",
    postType: "text",
    likes: 2134,
    comments: 456,
    shares: 178,
    userLiked: true,
    tags: ["RockNacional", "Clásicos", "Medianoche"],
  },
  {
    id: 12,
    authorType: "program",
    authorId: 6,
    authorName: "Éxito Total",
    authorAvatar: "https://readdy.ai/api/search-image?query=Popular%20morning%20radio%20show%20logo%20with%20sunburst%20and%20microphone%20elements%2C%20warm%20golden%20yellow%20and%20coral%20color%20scheme%2C%20cheerful%20energetic%20broadcast%20identity%2C%20circular%20emblem%2C%20clean%20vector%20design%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-prog-6&orientation=squarish",
    authorSubtitle: "Programa · Éxito FM · 4.1K seguidores",
    authorLink: "/program/exito-total",
    timestamp: "2026-06-19T20:00:00Z",
    content: "¡CONCURSO RELÁMPAGO! ⚡ El primer oyente que llame y cante el coro de la canción que estamos tocando AHORA se lleva un parlante Bluetooth edición limitada. 📞 555-0195 ¡LLAMÁ YA!",
    postType: "contest",
    contestPrize: "Parlante Bluetooth Edición Limitada RFW",
    contestEndDate: "2026-06-19T22:00:00Z",
    likes: 3456,
    comments: 1023,
    shares: 890,
    userLiked: false,
    tags: ["ConcursoRelámpago", "EnVivo", "Premio"],
  },
  {
    id: 13,
    authorType: "host",
    authorId: 5,
    authorName: "María José Salazar",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%20with%20bright%20engaging%20expression%2C%20wearing%20stylish%20cream%20blazer%2C%20warm%20natural%20studio%20lighting%20with%20soft%20shadows%2C%20charismatic%20editorial%20headshot%20photography%2C%20clean%20elegant%20composition&width=200&height=200&seq=feed-avatar-host-5&orientation=squarish",
    authorSubtitle: "Locutora · Estéreo Capital · 11.8K seguidores",
    authorLink: "/host/maria-jose-salazar",
    timestamp: "2026-06-19T16:30:00Z",
    content: "Detrás de escena de Capital Mix. Así preparamos cada programa para ustedes. El equipo, la producción, las risas... todo lo que no se ve al aire. ¿Les gusta este tipo de contenido? 🎬✨",
    postType: "video",
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20in%20radio%20production%20studio%2C%20team%20of%20hosts%20and%20producers%20collaborating%20around%20mixing%20console%2C%20warm%20natural%20lighting%20with%20soft%20shadows%2C%20candid%20documentary%20style%20photography%2C%20authentic%20workplace%20atmosphere%20with%20creative%20energy%2C%20professional%20broadcast%20environment&width=800&height=500&seq=feed-post-13&orientation=landscape",
    likes: 1876,
    comments: 234,
    shares: 89,
    userLiked: true,
    tags: ["BehindTheScenes", "Producción", "Radio"],
  },
  {
    id: 14,
    authorType: "radio",
    authorId: 12,
    authorName: "Noticias 24",
    authorAvatar: "https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20with%20globe%20and%20broadcast%20tower%20elements%2C%20professional%20navy%20and%20white%20color%20scheme%2C%20authoritative%20news%20broadcast%20emblem%2C%20circular%20design%2C%20clean%20vector%20style%20on%20transparent%20background&width=200&height=200&seq=feed-avatar-radio-12&orientation=squarish",
    authorSubtitle: "104.3 FM RFW · 6.5K seguidores",
    authorLink: "/radio/104-3",
    timestamp: "2026-06-19T12:00:00Z",
    content: "INFORME ESPECIAL: Radiografía de la economía digital en Latinoamérica. Datos exclusivos, análisis de expertos y lo que viene para el segundo semestre. 📊🌎",
    postType: "photo",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20news%20broadcast%20studio%20with%20large%20digital%20screen%20displaying%20economic%20data%20charts%20and%20world%20map%2C%20modern%20minimalist%20desk%20setup%2C%20cool%20blue%20and%20white%20ambient%20lighting%2C%20serious%20journalistic%20atmosphere%2C%20editorial%20photography%20with%20clean%20professional%20composition&width=800&height=500&seq=feed-post-14&orientation=landscape",
    likes: 567,
    comments: 145,
    shares: 234,
    userLiked: false,
    tags: ["Economía", "Latinoamérica", "InformeEspecial"],
  },
  {
    id: 15,
    authorType: "host",
    authorId: 18,
    authorName: "Valeria Duque",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20radio%20DJ%20portrait%20with%20cool%20confident%20expression%2C%20wearing%20trendy%20dark%20outfit%20with%20subtle%20accessories%2C%20modern%20urban%20studio%20background%20with%20ambient%20colored%20lighting%2C%20stylish%20editorial%20headshot%20photography%2C%20contemporary%20clean%20composition&width=200&height=200&seq=feed-avatar-host-18&orientation=squarish",
    authorSubtitle: "DJ · Juvenil FM · 9.4K seguidores",
    authorLink: "/host/valeria-duque",
    timestamp: "2026-06-19T00:30:00Z",
    content: "SESIÓN NOCTURNA 🎧 Esta noche mezclando lo mejor del indie, electrónica y pop alternativo. Conectate que esto recién empieza. ¿Qué canción no puede faltar? 🌙✨",
    postType: "text",
    likes: 2345,
    comments: 567,
    shares: 145,
    userLiked: true,
    tags: ["SesiónNocturna", "DJ", "Indie"],
  },
];